import { render, staticRenderFns } from "./provision-warning-bulk-messages.vue?vue&type=template&id=0ef40d43&scoped=true&"
import script from "./provision-warning-bulk-messages.vue?vue&type=script&lang=js&"
export * from "./provision-warning-bulk-messages.vue?vue&type=script&lang=js&"
import style0 from "./provision-warning-bulk-messages.vue?vue&type=style&index=0&id=0ef40d43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef40d43",
  null
  
)

export default component.exports